import React, { useState, useRef } from "react";

//Icons
import { ReactComponent as HelpIcon } from "../../../../assets/icons/svg/question-circle.svg";
import { ReactComponent as ClockIcon } from "../../../../assets/icons/svg/clock.svg";
import { ReactComponent as NotifyIcon } from "../../../../assets/icons/svg/notification-ding.svg";

//MUI
import { Typography, Button, IconButton, Switch, FormControlLabel, Divider } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Close as CloseIcon } from "@mui/icons-material";
//Modals
import CustomModal from "../../../modal/CustomModal";
import ItemDatesHelp from "../help/ItemDatesHelp";

export const EditDatesModal = () => {
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [notifyDate, setNotifyDate] = useState(null);
  const [expiryDate, setExpiryDate] = useState(null);
  const [opened, setOpened] = useState(false);
  const [openedDate, setOpenedDate] = useState(null);
  const [notifyOpen, setNotifyOpen] = useState(false);
  const [expiryOpen, setExpiryOpen] = useState(false);
  const [openedOpen, setOpenedOpen] = useState(false);
  const notifyInputRef = useRef();
  const expiryInputRef = useRef();
  const openedInputRef = useRef();

  const handleNotifyClick = (e) => {
    if (!notifyOpen) {
      setNotifyOpen(true);
      e.preventDefault();
      e.stopPropagation();
    } else if (notifyInputRef.current) {
      notifyInputRef.current.select();
    }
  };
  const handleExpiryClick = (e) => {
    if (!expiryOpen) {
      setExpiryOpen(true);
      e.preventDefault();
      e.stopPropagation();
    } else if (expiryInputRef.current) {
      expiryInputRef.current.select();
    }
  };
  const handleOpenedClick = (e) => {
    if (!openedOpen) {
      setOpenedOpen(true);
      e.preventDefault();
      e.stopPropagation();
    } else if (openedInputRef.current) {
      openedInputRef.current.select();
    }
  };

  const clearNotify = () => setNotifyDate(null);
  const clearExpiry = () => setExpiryDate(null);
  const clearOpened = () => setOpenedDate(null);

  const handleBack = () => {};
  const handleNext = () => {};

  return (
    <div className="w-full">
      <CustomModal open={showHelpModal} handleClose={() => setShowHelpModal(false)} type="bottom">
        <ItemDatesHelp />
      </CustomModal>
      <div className="p-4 bg-neutral-100 w-full flex flex-row justify-between items-center">
        <Typography variant="h6" className="font-normal">
          Edit Item Dates
        </Typography>
        <Button
          size="small"
          disableRipple
          className="hover:bg-transparent border-neutral-400 hover:border-neutral-500"
          variant="outlined"
          onClick={() => setShowHelpModal(true)}
        >
          <HelpIcon className="w-4 h-4 mr-1" />
          Help
        </Button>
      </div>
      <div className="p-4 flex flex-col gap-4 mt-2">
        <div>
          <div className="flex flex-row items-center gap-2 mb-6">
            <ClockIcon className="w-4 h-4 fill-primaryText" />
            <div>
              <Typography variant="subtitle1" className="font-normal">
                Item Lifetime
              </Typography>
              <Typography variant="subtitle2" className="font-normal text-xs text-secondaryText-600">
                When the item is still okay to use in recipes
              </Typography>
            </div>
          </div>
          <div>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <div className="flex flex-row gap-2">
                <div className="w-full flex flex-grow">
                  <DatePicker
                    label="Best Before"
                    value={expiryDate}
                    onChange={setExpiryDate}
                    format="yyyy-MM-dd"
                    open={expiryOpen}
                    onOpen={() => setExpiryOpen(true)}
                    onClose={() => setExpiryOpen(false)}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        variant: "outlined",
                        inputRef: expiryInputRef,
                        onClick: handleExpiryClick,
                      },
                    }}
                    clearable
                  />
                </div>
                {expiryDate && (
                  <IconButton size="small" onClick={clearExpiry}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                )}
              </div>
            </LocalizationProvider>
          </div>
          <div>
            <div className="flex items-center justify-between mb-2 mt-4">
              <FormControlLabel
                control={<Switch checked={opened} onChange={(_, checked) => setOpened(checked)} />}
                label={
                  <Typography variant="subtitle2" className="font-normal">
                    Opened
                  </Typography>
                }
              />
            </div>
            {opened && (
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <div className="flex flex-row gap-2 my-2">
                  <div className="w-full flex flex-grow">
                    <DatePicker
                      label="Opened Date"
                      value={openedDate}
                      onChange={setOpenedDate}
                      format="yyyy-MM-dd"
                      open={openedOpen}
                      onOpen={() => setOpenedOpen(true)}
                      onClose={() => setOpenedOpen(false)}
                      fullWidth
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          variant: "outlined",
                          inputRef: openedInputRef,
                          onClick: handleOpenedClick,
                        },
                      }}
                      clearable
                    />
                  </div>
                  {opened && openedDate && (
                    <IconButton size="small" onClick={clearOpened}>
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  )}
                </div>
              </LocalizationProvider>
            )}
          </div>
        </div>
        <Divider className="border-separator" />
        <div>
          <div className="flex flex-row items-center gap-2 mb-6">
            <NotifyIcon className="w-4 h-4 fill-primaryText" />
            <div>
              <Typography variant="subtitle1" className="font-normal">
                Item Priority
              </Typography>
              <Typography variant="subtitle2" className="font-normal text-xs text-secondaryText-600">
                We'll suggest recipes with this ingredient more often after this date
              </Typography>
            </div>
          </div>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <div className="flex flex-row gap-2">
              <div className="w-full flex flex-grow">
                <DatePicker
                  label="Notify Date"
                  value={notifyDate}
                  onChange={setNotifyDate}
                  format="yyyy-MM-dd"
                  open={notifyOpen}
                  onOpen={() => setNotifyOpen(true)}
                  onClose={() => setNotifyOpen(false)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      variant: "outlined",
                      inputRef: notifyInputRef,
                      onClick: handleNotifyClick,
                    },
                  }}
                  clearable
                />
              </div>
              {notifyDate && (
                <IconButton size="small" onClick={clearNotify}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              )}
            </div>
          </LocalizationProvider>
        </div>

        <div className="w-full mt-6">
          <Button variant="contained" color="primary" onClick={handleNext} disableRipple disableElevation fullWidth>
            Save
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EditDatesModal;
